import { Spinner } from "@chakra-ui/react";
import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import toast from "react-hot-toast";
// import toast from "react-hot-toast";

const CoolingPeriod = ({
  isOpen,
  setIsOpen,
  coolingPeriod,
  setCoolingPeriod,
  onSubmit,
  message,
  setMessage,
  verifyAndUpgradeKYCMutation,
  kycLevel,
}: any) => {
  console.log(kycLevel);
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md">
                <div className="bg-white px-4 pb-4 pt-5 sm:p-4 sm:pb-4">
                  <div className="">
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                      <Dialog.Title
                        as="h3"
                        className="text-base font-semibold leading-6 text-gray-900"
                      >
                        Set Cooling Period
                      </Dialog.Title>
                      <div className="mt-4">
                        {Number(kycLevel) === 1 && (
                          <div className="mt-2">
                            <label
                              htmlFor="days"
                              className="block text-sm font-medium leading-6 text-gray-900"
                            >
                              No of days
                            </label>
                            <div className="mt-2">
                              <input
                                id="days"
                                name="days"
                                type="number"
                                min={0}
                                value={coolingPeriod}
                                onChange={(e: any) => {
                                  const value = Math.max(
                                    0,
                                    parseInt(e.target.value)
                                  );
                                  setCoolingPeriod(value);
                                }}
                                required
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-0 ps-2 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                              />
                            </div>
                          </div>
                        )}
                        <div className="mt-2">
                          <label
                            htmlFor="comment"
                            className="block text-sm font-medium leading-6 text-gray-900"
                          >
                            Reason
                          </label>
                          <div className="mt-2">
                            <input
                              id="comment"
                              name="comment"
                              type="text"
                              value={message}
                              onChange={(e: any) => setMessage(e.target.value)}
                              required
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-0 ps-2 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-cyan-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-cyan-800 sm:ml-3 sm:w-auto ring-1 ring-inset ring-cyan-800"
                    onClick={() => {
                      if (message === "") {
                        toast.error("Comment should not be empty");
                        return;
                      }
                      onSubmit();
                    }}
                    disabled={verifyAndUpgradeKYCMutation?.isPending}
                  >
                    {verifyAndUpgradeKYCMutation?.isPending ? (
                      <Spinner />
                    ) : (
                      "Save"
                    )}
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => {
                      setIsOpen(false);
                      setCoolingPeriod(0);
                      setMessage("");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default CoolingPeriod;
